import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { HighlightedVideoSliderComponent } from '../highlighted-video-slider/highlighted-video-slider.component';
import { VideoItemComponent } from '../video-item/video-item.component';

@Component({
	selector: 'kwo-video-slider',
	templateUrl: './video-slider.component.html',
	styleUrls: ['./video-slider.component.scss'],
	standalone: true,
	imports: [CommonModule, SlickCarouselModule, HighlightedVideoSliderComponent, VideoItemComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoSliderComponent implements OnInit {

	@Input() slider: any;

	slideConfig = {};

	constructor() { }

	ngOnInit(): void {

		if (this.slider.mode == 'portrait') {

			this.slideConfig = {
				infinite: false,
				slidesToShow: 8,
				slidesToScroll: 8,
				centerMode: false,
				arrows: true,
				dots: false,
				touchThreshold: 20,
				prevArrow: '<div class="ngx_splide__arrow ngx_splide__arrow--prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></div>',
				nextArrow: '<div class="ngx_splide__arrow ngx_splide__arrow--next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></div>',
				responsive: [
					{
						breakpoint: 1920,
						settings: {
							arrows: true,
							centerMode: false,
							slidesToShow: 7,
							slidesToScroll: 7,
							speed: 80
						}
					},
					{
						breakpoint: 1600,
						settings: {
							arrows: true,
							centerMode: false,
							slidesToShow: 6,
							slidesToScroll: 6,
							speed: 80
						}
					},
					{
						breakpoint: 1400,
						settings: {
							arrows: true,
							centerMode: false,
							slidesToShow: 5,
							slidesToScroll: 5,
							speed: 80
						}
					},
					{
						breakpoint: 992,
						settings: {
							arrows: true,
							centerMode: false,
							slidesToShow: 3,
							slidesToScroll: 3,
							speed: 80
						}
					},
					{
						breakpoint: 768,
						settings: {
							arrows: false,
							slidesToShow: 2.5,
							slidesToScroll: 2,
							speed: 80
						}
					}
				]
			};
		}
		else {

			this.slideConfig = {
				infinite: false,
				slidesToShow: 5,
				slidesToScroll: 5,
				centerMode: false,
				arrows: true,
				dots: false,
				touchThreshold: 20,
				prevArrow: '<div class="ngx_splide__arrow ngx_splide__arrow--prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></div>',
				nextArrow: '<div class="ngx_splide__arrow ngx_splide__arrow--next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></div>',
				responsive: [
					{
						breakpoint: 1600,
						settings: {
							arrows: true,
							centerMode: false,
							slidesToShow: 4,
							slidesToScroll: 4,
							speed: 80
						}
					},
					{
						breakpoint: 1200,
						settings: {
							arrows: true,
							centerMode: false,
							slidesToShow: 3,
							slidesToScroll: 3,
							speed: 80
						}
					},
					{
						breakpoint: 992,
						settings: {
							arrows: true,
							centerMode: false,
							slidesToShow: 3,
							slidesToScroll: 3,
							speed: 80
						}
					},
					{
						breakpoint: 768,
						settings: {
							arrows: false,
							slidesToShow: 2.5,
							slidesToScroll: 2,
							speed: 80
						}
					}
				]
			};
		}
	}
}